'use client'
/**
 * @typedef {import("@prismicio/client").Content.ProjectsSlice} ProjectsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ProjectsSlice>} ProjectsProps
 * @param {ProjectsProps}
 */

import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";
import { useEffect } from "react";


const ProjectItemMobile = ({ slice }) => {

  useEffect(() => {
    const $imgParentBorder = Array.from(document.querySelectorAll('.img-parent-border'));
    if ($imgParentBorder != null) obeserveImg($imgParentBorder)
  });

  function obeserveImg(elem) {
    const obs = {
      rootMargin: '',
      threshold: 1,
    }

    function cb(entries) {
      entries.forEach(entry => {
        const t = entry.target
        if (Array.from(t.classList).join(' ').includes('round-it')) return;
        if (entry.isIntersecting) {
          t.classList.add('rounded-it');
        }
      });
    };
    const observer = new IntersectionObserver(cb, obs);
    elem.forEach(element => observer.observe(element));
  }

  return <div className="pt-30px md:pt-20 text-dark-grey">
    <div className="px-4 md:px-7 mb-30px max-w-[600px]">
      <h2 className="subtitle mb-5"> {slice.primary.projects_seo_title} </h2>
      <div>
        <div className="h2-like mb-3.5">
          <PrismicRichText field={slice.primary.title} />
        </div>
        <div>
          <PrismicRichText field={slice.primary.text} />
        </div>
      </div>
    </div>
    <div className="flex gap-x-4 md:gap-x-5">
      <div className="w-1/2 lg:w-1/3 text-end">
        <div className="mb-30px">
          <div className="mb-2.5 img-parent-border overflow-hidden rounded-t">
            <PrismicImage field={slice.primary.projects[0].project.data.preview_picture} className="w-full h-[275px] md:h-[400px] object-cover" loading="lazy"/>
          </div>
          <div className="text-info">
            <PrismicRichText field={slice.primary.projects[0].project.data.preview_name} />
          </div>
        </div>
        <div className="mb-30px lg:hidden">
          <div className="mb-2.5 img-parent-border overflow-hidden rounded-tl">
            <PrismicImage field={slice.primary.projects[1].project.data.preview_picture} className="w-full h-[190px] md:h-[300px] object-cover" loading="lazy"/>
          </div>
          <div className="text-info">
            <PrismicRichText field={slice.primary.projects[1].project.data.preview_name} />
          </div>
        </div>
      </div>
      <div className="w-1/2 lg:w-1/3">
        <div className="mb-30px">
          <div className="mb-2.5 img-parent-border overflow-hidden rounded-tl">
            <PrismicImage field={slice.primary.projects[2].project.data.preview_picture} className="w-full h-[190px] md:h-[300px] object-cover" loading="lazy"/>
          </div>
          <div className="text-info">
            <PrismicRichText field={slice.primary.projects[2].project.data.preview_name} />
          </div>
        </div>
        <div className="mb-30px">
          <div className="mb-2.5 img-parent-border overflow-hidden rounded-b">
            <PrismicImage field={slice.primary.projects[3].project.data.preview_picture} className="w-full h-[275px] md:h-[400px] object-cover" loading="lazy"/>
          </div>
          <div className="text-info">
            <PrismicRichText field={slice.primary.projects[3].project.data.preview_name} />
          </div>
        </div>
      </div>
    </div>
    <div className="px-4 text-center text-dark-grey">
      <div className="button button-rounded button-text overflow-hidden background-slide-white">
        <PrismicLink field={slice.primary.cta_page}>{slice.primary.cta_label}</PrismicLink>
      </div>
    </div>
  </div >
}

const ProjectItemDesktop = ({ slice }) => {

  function setRounded(event) {
    const t = event.currentTarget;
    if (Array.from(t.classList).join(' ').includes('rounded')) return;
    if (t.clientWidth + 30 < t.clientHeight) {
      Math.random() > .5 ? t.classList.add('rounded-t') : t.classList.add('rounded-bl'); // Randomly add rounded corners
    } else {
      t.classList.add('rounded-tl');
    }
  }

  return <div className="max-w-[1300px] m-auto pt-[60px] pb-20 px-10 text-dark-grey">
    <h2 className="subtitle mb-5">
      {slice.primary.seo_title}
    </h2>
    <div className="flex justify-between">
      <div className="w-[350px] mr-[52px]">
        <div className="mb-10">
          <div className="h2-like mb-3.5">
            <PrismicRichText field={slice.primary.title} />
          </div>
          <div>
            <PrismicRichText field={slice.primary.text} />
          </div>
        </div>
        <div className="car-wrapper-item overflow-hidden mb-5" onMouseEnter={setRounded}>
          <PrismicImage field={slice.primary.projects[0].project.data.preview_picture} className="w-full w-[350px] h-[540px] border-0 object-cover" loading="lazy"/>
        </div>
        <div className="text-info h-[100px]">
          <PrismicRichText field={slice.primary.projects[0].project.data.preview_name} />
        </div>
      </div>
      <div className="w-[350px] mr-[52px] flex flex-col justify-between">
        <div>
          <div className="car-wrapper-item overflow-hidden mb-5 aspect-square" onMouseEnter={setRounded}>
            <PrismicImage field={slice.primary.projects[1].project.data.preview_picture} className="w-full border-0 object-cover w-[350px] h-[350px]" loading="lazy"/>
          </div>
          <div className="text-info h-[100px]">
            <PrismicRichText field={slice.primary.projects[1].project.data.preview_name} />
          </div>
        </div>
        <div>
          <div className="car-wrapper-item overflow-hidden mb-5 aspect-square" onMouseEnter={setRounded}>
            <PrismicImage field={slice.primary.projects[2].project.data.preview_picture} className="w-full border-0 object-cover w-[350px] h-[350px]" loading="lazy"/>
          </div>
          <div className="text-info h-[100px]">
            <PrismicRichText field={slice.primary.projects[2].project.data.preview_name} />
          </div>
        </div>
      </div>
      <div className="w-[350px]">
        <div className="mb-[70px]">
          <div className="car-wrapper-item overflow-hidden mb-5" onMouseEnter={setRounded}>
            <PrismicImage field={slice.primary.projects[3].project.data.preview_picture} className="w-[350px] h-[540px] border-0 object-cover" loading="lazy"/>
          </div>
          <div className="text-info h-[100px]">
            <PrismicRichText field={slice.primary.projects[3].project.data.preview_name} />
          </div>
        </div>
        <div className="px-5 m-auto text-center">
          <div className="button button-rounded button-text overflow-hidden background-slide-white">
            <PrismicLink field={slice.primary.cta_page}>{slice.primary.cta_label}</PrismicLink>
          </div>
        </div>
      </div>
    </div>
  </div>
}

const Projects = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-white bg-grain pb-[40px] md:pb-20 overflow-hidden ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
      <div className="block lg:hidden ">
        <ProjectItemMobile slice={slice} />
      </div>
      <div className="hidden lg:block">
        <ProjectItemDesktop slice={slice} />
      </div>
    </section >
  );
};

export default Projects;
